var map = {
	"./daniel.jpg": 392,
	"./didrik.jpg": 9544,
	"./generic.jpg": 9531,
	"./hakon.jpg": 6044,
	"./ine.jpg": 9818,
	"./jacob.jpg": 963,
	"./kasper.jpg": 7000,
	"./konstanse.jpg": 6694,
	"./logo.png": 7678,
	"./mikkel.jpg": 9038,
	"./nithusha.jpg": 7461,
	"./ove.jpg": 8721,
	"./sandra.jpg": 4730,
	"./victoria.jpg": 1198
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1134;